import { useMemo } from 'react';

function getCssVar(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(name).trim();
}

export function useChartColors(count = 8): string[] {
  return useMemo(() => {
    const colors: string[] = [];
    for (let i = 1; i <= count; i++) {
      const c = getCssVar(`--chart-${i}`);
      if (c) colors.push(c);
    }
    if (colors.length === 0) {
      return ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#22c55e', '#06b6d4', '#f43f5e', '#a855f7'];
    }
    return colors;
  }, [count]);
}

export function useWidgetColors(count = 6): string[] {
  return useMemo(() => {
    const colors: string[] = [];
    for (let i = 1; i <= count; i++) {
      const c = getCssVar(`--widget-${i}`);
      if (c) colors.push(c);
    }
    if (colors.length === 0) {
      return ['#3b82f6', '#8b5cf6', '#ec4899', '#f59e0b', '#22c55e', '#06b6d4'];
    }
    return colors;
  }, [count]);
}
